import "./style.scss";
import * as React from "react";
import { Link } from "react-router-dom";
import { CurrentUserContainer } from "../../../User";
import { sendGAEvent } from "../../../common/google_analytics";
import { HeaderProps } from "./container";
import Feature from "../../../common/components/Feature";

interface NavBarProps {
  permissions: any;
}

class Navbar extends React.Component<NavBarProps, {}> {
  render() {
    let { permissions } = this.props;

    return (
      <div className="navbar">
        {permissions.retailer_reporting_access && (
          <Link className="title" to="/merchants" data-automation-id="menu-add">
            Automated Data Delivery
          </Link>
        )}

        {permissions.access_marketplace_dashboard && (
          <Link
            className="title"
            to="/analytics"
            data-automation-id="menu-analytics"
          >
            Analytics
          </Link>
        )}

        {permissions.store_visits_access && (
          <Feature flag="store_visits_ui">
            <Link
              className="title"
              to="/store-visits"
              data-automation-id="menu-store-visits"
            >
              Store Trips
            </Link>
          </Feature>
        )}

        {/* <p className="tab-seperator">|</p>
        <Link className="title-admin" to="/admin">Admin</Link> */}
      </div>
    );
  }
}

class Navlogo extends React.Component<{}, {}> {
  render() {
    return (
      <div className="nav-logo">
        <img src="/flipp-white.png" />
        <span>DASHBOARD</span>
      </div>
    );
  }
}

class Header extends React.Component<HeaderProps, {}> {
  handleBackToClassicClick = () => {
    const { gaUserContext, merchantName } = this.props;
    sendGAEvent("Analytics", "Back to Classic", merchantName, gaUserContext);

    const MPDashboardUrl =
      process.env.NODE_ENV == "production"
        ? "marketplace.wishabi.com"
        : "marketplace-staging.wishabi.com";
    location.href = `https://${MPDashboardUrl}/dashboard#/reach`;
  };

  render() {
    return (
      <div className="header">
        <div className="content-wrapper pure-u-g">
          <div className="pure-u-1-2">
            <Navlogo />
            {/*<Navbar permissions={this.props.permissions}/>*/}
          </div>
          <div className="pure-u-1-2 right">
            <CurrentUserContainer />
          </div>
        </div>
      </div>
    );
  }
}

export default Header as any;



// WEBPACK FOOTER //
// ./client/modules/common/components/Header/component.tsx